// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "de791a1e116538fb4f8d24d8cd6f75ca" + ".css";
};